import React from 'react';
import { RepresentationType } from 'shared/enums/RepresentationType';
import { IAuditionSchedulesAttributes } from 'shared/interfaces/IAuditionSchedule';
import { profileService } from 'shared/services/profileService';
import { audDateTime, stDateTime } from 'shared/utils/timeHelpers';
import AuditionRequestItem from '../AuditionItem/AuditionItem';
import { AuditionItemsContainer, Heading, ScrollCont } from '../Audtion.styles';
import LoadingCont from '../LoadingCont';
import { MainCont, NoData } from './AuditionRequests.styles';
import { useAppSelector } from 'shared/redux/store';

interface Props {
  data: IAuditionSchedulesAttributes[];
  isLoading: boolean;
}

const { getProfiles } = profileService();

const AuditionRequests: React.FC<Props> = ({ data, isLoading }) => {
  const { data: dataProfiles } = getProfiles();
  const { user: userState } = useAppSelector((state: any) => state);
  const country = userState?.user?.attributes?.other_phone_numbers?.filter((num) => num.type === 'primary');
  const userCountry = country && country.length > 0 ? country[0].country_code.toLowerCase() : 'au';

  const sortedData = () =>
    data.sort((a: any, b: any) => {
      const dateTimeA = a.phase === 'Self Tapes Request' ? stDateTime(a) : audDateTime(a);
      const dateTimeB = b.phase === 'Self Tapes Request' ? stDateTime(b) : audDateTime(b);
      return (dateTimeA as any) - (dateTimeB as any);
    });

  const hasAgency = !!dataProfiles?.data.some(
    (data) => data.attributes.representation_type === RepresentationType.AGENCY_REPRESENTATION,
  );

  return isLoading ? (
    <LoadingCont />
  ) : (
    <MainCont>
      {data.length !== 0 ? (
        <>
          <Heading>Please respond to your audition requests below:</Heading>
          <ScrollCont>
            <AuditionItemsContainer>
              {sortedData().map((d) => (
                <AuditionRequestItem country={userCountry} request data={d} />
              ))}
            </AuditionItemsContainer>
          </ScrollCont>
        </>
      ) : (
        // <EmptyCameraNotification>
        //   It’ll be a matter of time before someone discovers your talent.{' '}
        //   {hasAgency ? 'Ask your agency on how Casting Directors could find you.' : ''}
        // </EmptyCameraNotification>
        <NoData>No Data Available</NoData>
      )}
    </MainCont>
  );
};

export default AuditionRequests;
